import React from "react";

export default function DownloadCostPdf({
    title = "Overall Cost Report",
    generatedAt,
    slot,
    tableRows = [],
    footerData = [],
}) {
    const styles = {
        body: {
            fontFamily: "DejaVu Sans, sans-serif",
            fontSize: "10px",
            color: "#333",
            padding: "0px 12px",
        },
        title: {
            fontSize: "18px",
            textAlign: "center",
            marginBottom: "10px",
            fontWeight: "bold",
        },
        meta: {
            fontSize: "12px",
            textAlign: "center",
            marginBottom: "5px",
        },
        table: {
            width: "100%",
            minWidth: "600px",
            borderCollapse: "collapse",
            marginBottom: "40px",
        },
        th: {
            border: "1px solid #c6c6c6",
            padding: "8px",
            textAlign: "center",
            backgroundColor: "#666666",
            color: "#ffffff",
            fontWeight: "bold",
            WebkitPrintColorAdjust: "exact",
            printColorAdjust: "exact",
        },
        td: {
            border: "1px solid #c6c6c6",
            paddingLeft: "3px",
        },
    };

    return (
        <div style={styles.body} id="pdf-content">
            {/* HEADER */}
            <div style={styles.title}>Garuda Agency - {title}</div>

            {slot && (
                <div style={styles.meta}>
                    Date: {slot.date} &nbsp; | &nbsp; Lot: {slot.lot_name} &nbsp; | &nbsp;
                    Time: {slot.time}
                </div>
            )}

            {generatedAt && (
                <div style={styles.meta}>Report Generated on: {generatedAt}</div>
            )}
            <style>
                {`
                 #pdf-content thead th {
    background-color: #666666 !important;
    color: #ffffff !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    padding: '6px';
  }
  /* Header print color */
  #pdf-content thead th {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  /* Default table + row background → WHITE */
  #pdf-content table {
    background-color: #ffffff !important;
  }

`}
            </style>
            {/* TABLE */}
            <table style={styles.table}>
                {/* THEAD */}
                <thead>
                    <tr>
                        {[
                            "Date",
                            "Time",
                            "Lot",
                            "Details",
                            "Sales Qty",
                            "Draw Qty",
                            "Sale Cost",
                            "Draw Cost",
                            "P & L",
                        ].map((head, i) => (
                            <th key={i} style={styles.th}>
                                {head}
                            </th>
                        ))}
                    </tr>
                </thead>

                {/* TBODY */}
                <tbody>
                    {tableRows.map((row, index) => (
                        <tr key={index}>
                            <td style={{ ...styles.td, minWidth: 95 }}>{row.date ?? ""}</td>
                            <td style={styles.td}>{row.time ?? ""}</td>
                            <td style={styles.td}>{row.lot ?? ""}</td>
                            <td style={{ ...styles.td, minWidth: 195 }}>
                                {row.details ?? ""}
                            </td>
                            <td style={styles.td}>{row.sales_qty ?? 0}</td>
                            <td style={styles.td}>{row.draw_qty ?? 0}</td>
                            <td style={styles.td}>{row.sale_cost ?? 0}</td>
                            <td style={styles.td}>{row.draw_cost ?? 0}</td>
                            <td style={styles.td}>{row.p_l ?? 0}</td>
                        </tr>
                    ))}
                </tbody>

                {/* TFOOT */}
                <tfoot>
                    {footerData.map((item, index) => {
                        const isLast = index === footerData.length - 1;

                        return (
                            <tr
                                key={index}
                                style={{
                                    backgroundColor: '#f6dcb5',
                                    fontFamily: isLast ? "f3" : "f2",
                                    WebkitPrintColorAdjust: "exact",
                                    printColorAdjust: "exact",
                                }}
                            >

                                {/* DETAILS */}
                                <td colSpan={6}
                                    style={{
                                        // borderTop: "1px solid #A70000",
                                        // borderBottom: "1px solid #A70000",
                                        border: "1px solid #c6c6c6",
                                        paddingLeft: "3px",
                                        textAlign: "center"
                                        // color: "#ffffff",
                                    }}
                                >
                                    {item.details ?? ""}
                                </td>






                                {/* SALE COST */}
                                <td
                                    style={{
                                        // borderTop: "1px solid #A70000",
                                        // borderBottom: "1px solid #A70000",
                                        border: "1px solid #c6c6c6",
                                        paddingLeft: "3px",
                                        // color: "#ffffff",
                                    }}
                                >
                                    {item.sale_cost ?? 0}
                                </td>

                                {/* DRAW COST */}
                                <td
                                    style={{
                                        // borderTop: "1px solid #A70000",
                                        // borderBottom: "1px solid #A70000",
                                        border: "1px solid #c6c6c6",
                                        paddingLeft: "3px",
                                        // color: "#ffffff",
                                    }}
                                >
                                    {item.draw_cost ?? 0}
                                </td>

                                {/* P & L */}
                                <td
                                    style={{
                                        // borderTop: "1px solid #A70000",
                                        // borderBottom: "1px solid #A70000",
                                        // borderRight: "1px solid #A70000",
                                        border: "1px solid #c6c6c6",
                                        paddingLeft: "3px",
                                        // color: "#ffffff",
                                    }}
                                >
                                    {item.p_l ?? 0}
                                </td>
                            </tr>
                        );
                    })}
                </tfoot>
            </table>
        </div>
    );
}
